export default __webpack_public_path__ + "static/media/dogcap.28113795.png";